export const GET_CAMPAIGNS = 'GET_CAMPAIGNS';
export const CREATE_CAMPAIGN = "CREATE_CAMPAIGN";
